import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const ShoppingCartSolidSvg = ({ width, height, color, ...rest }: Props) => (
  <svg width={width} height={height} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} >
    <path
      d="M6.48106 16C5.68339 16 4.98543 16.7 4.98543 17.5C4.98543 18.3 5.68339 19 6.48106 19C7.27873 19 7.97669 18.3 7.97669 17.5C7.97669 16.7 7.27873 16 6.48106 16ZM16.9505 13H4.98543C4.38718 13 3.98835 12.6 3.98835 12C3.98835 11.4 4.38718 11 4.98543 11H13.4607C14.7569 11 15.9534 10.1 16.3522 8.8L17.9476 3.3C18.147 2.8 17.7481 2.2 17.2496 2.1C17.1499 2.1 17.0502 2.1 16.9505 2.1H4.68631C4.28747 0.8 3.19068 0 1.89446 0H0.997087C0.398835 0 0 0.4 0 1C0 1.6 0.398835 2 0.997087 2H1.89446C2.2933 2 2.69213 2.3 2.89155 2.7L2.99126 3.3L4.68631 9C2.99126 9.2 1.79476 10.7 1.99417 12.3C2.19359 13.8 3.4898 15 4.98543 15H16.9505C17.5487 15 17.9476 14.6 17.9476 14C17.9476 13.4 17.5487 13 16.9505 13ZM14.4578 16C13.6601 16 12.9621 16.7 12.9621 17.5C12.9621 18.3 13.6601 19 14.4578 19C15.2554 19 15.9534 18.3 15.9534 17.5C15.9534 16.7 15.2554 16 14.4578 16Z"
      fill={color}
    />
  </svg>
)

ShoppingCartSolidSvg.defaultProps = {
  width: 18,
  height: 19,
  color: colors.Primary.GreyText
}

export default ShoppingCartSolidSvg
